import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ndt-card',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './card-layout.component.html',
    styleUrls: ['./card-layout.component.scss'],
    standalone: false
})
export class CardLayoutComponent {
   @Input() title = '';
}
